import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { useAuthContext } from './context/AuthContext';
import { evalRoutes } from './eval/routes';
import { ForgeLayout } from './forge/components/layout/ForgeLayout';
import { MasterLabelPage } from './forge/pages/admin/MasterLabelPage';
import { forgeRoutes } from './forge/routes';
import { CandidateDetailPage } from './pages/embeddings/CandidateDetailPage';
import { CandidatesPage } from './pages/embeddings/CandidatesPage';
import EmbeddingDetailPage from './pages/embeddings/EmbeddingDetailPage';
import { EmbeddingsPage } from './pages/embeddings/EmbeddingsPage';
import { OutsSelectionPage } from './pages/embeddings/OutsSelectionPage';
import { GroundTruthAuditPage } from './pages/ground-truth/GroundTruthAuditPage';
import { ModEligibilityPage } from './pages/mod-eligibility/ModEligibilityPage';
import { StoreDetailsPage } from './pages/store-details/StoreDetailsPage';
import StoresPage from './pages/stores/StoresPage';
import { ImageAuditPageWrapper } from './pages/tasks/ImageAuditPageWrapper';
import { TaskAuditPageWrapper } from './pages/tasks/TaskDetailPageWrapper';
import { TasksPage } from './pages/tasks/TasksPage';

const RootRedirect: React.FC = () => {
  const { hasInternalAccess } = useAuthContext();
  return <Navigate to={hasInternalAccess ? '/stores' : '/embeddings/detail'} replace />;
};

const ProtectedRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const { hasInternalAccess } = useAuthContext();

  if (!hasInternalAccess) {
    return <Navigate to="/embeddings/detail" replace />;
  }

  return element;
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootRedirect />,
  },
  {
    path: '/stores',
    element: <ProtectedRoute element={<StoresPage />} />,
  },
  {
    path: '/stores/:storeName/mod-eligibility',
    element: <ProtectedRoute element={<ModEligibilityPage />} />,
  },
  {
    path: '/stores/:storeName/:deviceName?',
    element: <ProtectedRoute element={<StoreDetailsPage />} />,
  },
  {
    path: '/embeddings',
    element: <ProtectedRoute element={<EmbeddingsPage />} />,
  },
  {
    path: '/embeddings/detail',
    element: <EmbeddingDetailPage />,
  },
  {
    path: '/tasks',
    element: <ProtectedRoute element={<TasksPage />} />,
  },
  {
    path: '/tasks/:taskId',
    element: <ProtectedRoute element={<TaskAuditPageWrapper />} />,
  },
  {
    path: '/gt/audit/:gtSampleId',
    element: <ProtectedRoute element={<GroundTruthAuditPage />} />,
  },
  {
    path: '/images/:imageId/audit',
    element: <ProtectedRoute element={<ImageAuditPageWrapper />} />,
  },
  {
    path: '/embeddings/candidates',
    element: <ProtectedRoute element={<CandidatesPage />} />,
  },
  {
    path: '/embeddings/candidates/:imageId',
    element: <CandidateDetailPage />,
  },
  {
    path: '/forge/admin/master-label',
    element: <ForgeLayout />,
    children: [{ index: true, element: <MasterLabelPage /> }],
  },
  {
    ...forgeRoutes,
    element: <ProtectedRoute element={forgeRoutes.element as React.ReactElement} />,
  },
  {
    ...evalRoutes,
    element: <ProtectedRoute element={evalRoutes.element as React.ReactElement} />,
  },
  {
    path: '/outs-selection/:imageId',
    element: <OutsSelectionPage />,
  },
]);

export const App: React.FC = () => {
  return <RouterProvider router={router} />;
};
